import { defaultIconProps, IconProps } from './IconProps';

export const IconCloseMultiSelect: import('react').FC<IconProps> = ({ size = defaultIconProps.size, color = defaultIconProps.color, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M9 3L3 9M3 3L9 9" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
